// extracted by mini-css-extract-plugin
module.exports = {"f-OrganismErrorMessage":"ErrorMessage_f-OrganismErrorMessage__x1RT4","f-OrganismErrorMessage-image":"ErrorMessage_f-OrganismErrorMessage-image__OhF1Z"};